module.exports = __webpack_public_path__ + "static/media/dubard.a6761076.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pictures/dubard.jpg
// module id = 324
// module chunks = 0